import React from 'react';

import { useFileEntryViewerInfoPanel } from '../../../store/fileEntryViewer.infoPanel.store';

const CommentsTabHeader = () => {
  const { infoPanelQueries } = useFileEntryViewerInfoPanel();
  const { useCommentsQuery } = infoPanelQueries.comments;
  const commentsQuery = useCommentsQuery();
  const totalCount = commentsQuery.data?.data.length || 0;

  return <React.Fragment>Comments {totalCount > 0 && `(${totalCount})`}</React.Fragment>;
};

export default CommentsTabHeader;
